<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright" id="ch00_fm03_copy"><a id="page_iv"></a><span class="small">NEW YORK UNIVERSITY PRESS</span><br/>New York and London<br/><span class="weblink"><a class="nounder" href="http://www.nyupress.org" target="_blank">www.nyupress.org</a></span></p>
<p class="copyright">© 2006 by New York University<br/>All rights reserved</p>
<p class="copyright">Library of Congress Cataloging–in–Publication Data<br/>Young, Alfred Fabian, 1925–<br/>Liberty tree: ordinary people and the American<br/>Revolution / Alfred F. Young.<br/>p. cm.<br/>Includes bibliographical references and index.<br/>ISBN–13: 978–0–8147–9685–6 (cloth: alk. paper)<br/>ISBN–10: 0–8147–9685–0 (cloth: alk. paper)<br/>ISBN–13: 978–0–8147–9686–3 (pbk.: alk. paper)<br/>ISBN–10: 0–8147–9686–9 (pbk.: alk. paper)<br/>1. United States—History—Revolution, 1775–1783—Social<br/>aspects. 2. Radicalism—United States—History—18th<br/>century. I. Title.<br/>E.209.Y68  2006<br/>973.3—dc22           2006008340</p>
<p class="copyright">New York University Press books are printed on acid-free paper,<br/>and their binding materials are chosen for strength and durability.</p>
<p class="copyright">Manufactured in the United States of America</p>
<p class="copyright">c 10 9 8 7 6 5 4 3 2 1<br/>p 10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm03_copy.vue?08d35fd2